import TableListBrowser from 'features/common/components/table-list-browser/TableListBrowser';
import React, { useMemo } from 'react';
import { leasingIncomeSchemasStore } from '../store';
import { LEASING_INCOME_SCHEMAS } from '../../queries';
import { CollectionType } from '@ts-private/list-browser';
import ApolloFetchingComponent from 'features/common/components/apollo-fetching/ApolloFetchingComponent';
import ItemComponent from './ItemComponent';
import { ExportModalComponent } from 'components/common/export/ExportModalComponent';
import { GENERIC_ENTITY_BUSINESS_STATES_QUERY } from 'features/genericEntityFlow/list/queries';
import { Card } from '@totalsoft/rocket-ui';
import ListAlt from '@mui/icons-material/ListAlt';
import { useToast } from 'hooks/toasts/useToast';
import { useTranslation } from 'react-i18next';
import useSubscription from 'hooks/apollo/useSubscription';
import { LEASING_INCOME_SCHEMA_DELETED } from 'features/leasingIncomeSchema/subscriptions';

const BrowserComponent = () => {
  const { t } = useTranslation();
  const addToast = useToast();

  // #region Subscriptions

  useSubscription(LEASING_INCOME_SCHEMA_DELETED, {
    onData: ({ client }) => {
      addToast(t('LeasingIncomeSchema.Deleted'), 'success');
      client.cache.evict({ id: 'ROOT_QUERY', fieldName: 'leasingIncomeSchemas' });
    }
  });

  // #endregion

  const fetchingOptions = useMemo(
    () => ({
      queryOptions: {
        query: LEASING_INCOME_SCHEMAS,
        name: 'leasingIncomeSchemas'
      },
      collectionsOptions: [
        {
          queryOptions: { query: GENERIC_ENTITY_BUSINESS_STATES_QUERY },
          name: 'genericEntityBusinessStates',
          identifier: 'stateId',
          collectionType: CollectionType.Filter,
          valueKey: 'stateId',
          labelKey: 'stateName'
        }
      ]
    }),
    []
  );

  const columns = useMemo(
    () => [
      { name: 'code', caption: 'LeasingIncomeSchema.Code', width: '20%' },
      { name: 'name', caption: 'LeasingIncomeSchema.Name' },
      { name: 'isActive', caption: 'LeasingIncomeSchema.IsActive', align: 'center', width: '15%' },
      { name: 'state', caption: 'LeasingIncomeSchema.State', width: '20%' },
      { name: 'actions', caption: 'Actions', width: '120px' }
    ],
    []
  );

  return (
    <Card icon={ListAlt}>
      <TableListBrowser store={leasingIncomeSchemasStore} ItemComponent={ItemComponent} columns={columns} />
      <ExportModalComponent store={leasingIncomeSchemasStore} options={fetchingOptions} />
      <ApolloFetchingComponent store={leasingIncomeSchemasStore} options={fetchingOptions} />
    </Card>
  );
};

export default BrowserComponent;
